module.exports = __webpack_public_path__ + "img/systock.2cef4648.png";